
define(
	'ROOM4.CCAProductGallery.CCAProductGallery'
,   [
		'ROOM4.CCAProductGallery.CCAProductGallery.List.View'
	,	'ROOM4.CCAProductGallery.CCAProductGallery.Details.View'
	,	'ROOM4.CCAProductGallery.CCAProductGallery.Maintenance.View'
	,	'ROOM4.CCAProductGallery.CCAProductGallery.HeaderGalleryButton.EntryPoint'
	,	'Configuration'
	]
,   function (
		CCAProductGalleryListView
	,	CCAProductGalleryDetailsView
	,	CCAProductGalleryMaintenanceView
	,	HeaderGalleryButtonEntryPoint
	,	Configuration
	)
{
	'use strict';

	function enablePinchZoom ()
	{
		if (typeof document === 'undefined')
		{
			return;
		}

		var viewportMeta = document.querySelector('meta[name="viewport"]');

		if (viewportMeta)
		{
			viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0');
		}
	}

	return  {
		mountToApp: function mountToApp (container)
		{
			enablePinchZoom();

			var pageType = container.getComponent('PageType');
			var maintenanceEnabled = Configuration.get('CCAProductGallery.maintenance.enabled') === true;
			var detailsView = maintenanceEnabled ? CCAProductGalleryMaintenanceView : CCAProductGalleryDetailsView;
			var listView = maintenanceEnabled ? CCAProductGalleryMaintenanceView : CCAProductGalleryListView;

			if (pageType)
			{
				pageType.registerPageType({
					name: 'CCAProductGallery.Details',
					routes: ['gallery/:vehicleMake/:vehicleModel/:vehicleYear/:galleryItemSlug'],
					view: detailsView
				});

				pageType.registerPageType({
					name: 'CCAProductGallery.List',
					routes: [
						'gallery',
						'gallery?*options',
						'gallery/:vehicleMake',
						'gallery/:vehicleMake/:vehicleModel',
						'gallery/:vehicleMake/:vehicleModel/:vehicleYear'
					],
					view: listView
				});
			}

			HeaderGalleryButtonEntryPoint.mountToApp(container);
		}
	};
});
